var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('span')]),_c('div',{ref:"total",staticClass:"total"})])}
var staticRenderFns = []

export { render, staticRenderFns }